import { type ReactElement } from 'react'
import { type Edge, ConnectionLayer } from '../../../connectionLayer'
import { useTeamHierarchyContext } from '../TeamHierarchyContext'

export const TeamConnectionsLayer = (): ReactElement => {
  const { teams, connectionSettings } = useTeamHierarchyContext()
  const edges: Edge[] = teams
    .filter((team) => team.parentId)
    .map((team) => ({
      start: team.parentId!,
      end: team.teamId,
    }))

  return <ConnectionLayer edges={edges} options={connectionSettings} />
}
